export const Colors = {
  background: '#F1EFF1',
};
